<script setup lang="tsx">
import type { User } from '@/models/api-generated'
import { nextTick, ref, watch } from 'vue'
import Autocomplete from 'bootstrap5-autocomplete'

const props = defineProps({
	id: String,
	disabled: Boolean,
})

const model = defineModel<User>()
const elementRef = ref<HTMLInputElement>()
let user: Autocomplete | undefined

watch(model, (m) => {
	nextTick(() => {
		if (user?._searchInput) user._searchInput.value = m?.label ?? ''
	})
})

watch(elementRef, (el) => {
	if (el) {
		if (user) user.dispose()

		user = new Autocomplete(el, {
			queryParam: 'q',
			searchFields: ['firstname', 'lastname'],
			labelField: 'label',
			valueField: 'id',
			server: 'api/users?showActive=true',
			serverDataKey: 'data',
			liveServer: true,
			suggestionsThreshold: 0,
			onSelectItem: (item: User, _: Autocomplete) => {
				model.value = item
			},
			onChange: (item: User | undefined, _: Autocomplete) => {
				model.value = item
			},
		})

		nextTick(() => {
			if (user?._searchInput) user._searchInput.value = model.value?.label ?? ''
		})
	}
})
</script>

<template>
	<input :id="props.id" :disabled="props.disabled" ref="elementRef" type="search" class="form-control" />
</template>
